import t from './story07.translations'

export default {
  title: t.title,
  excerpt: t.excerpt,
  regionName: t.regionName,

  prose: [
    // Run 1 — the open, no heading: what rare earths are and why concentration bites.
    [{ text: t.s1P1 }, { text: t.s1P2 }, { text: t.s1P3 }],
    [{ text: t.s1P4 }, { text: t.s1P5 }],
    // Run 2 — first themed section, up to the Muggah pull quote.
    [
      { title: t.s2Title, text: t.s2P1 },
      { text: t.s2P2 },
      { text: t.s2P3 },
      { text: t.s2P4 },
    ],
    // Run 3 — second themed section: dysprosium and the Ukrainian Shield.
    [
      { title: t.s3Title, text: t.s3P1 },
      { text: t.s3P2 },
      { text: t.s3P3 },
      { text: t.s3P4 },
    ],
    // Run 4 — third themed section. `s4P1`/`s4P2` and `s4P3`/`s4P4` are each one doc
    // block split by a hard line break, authored as the two paragraphs they read as.
    [
      { title: t.s4Title, text: t.s4P1 },
      { text: t.s4P2 },
      { text: t.s4P3 },
      { text: t.s4P4 },
      { text: t.s4P5 },
    ],
    // Run 5 — fourth themed section, straight after the previous one: no interruption
    // between them, but a heading only ever sits on a run's first block.
    [{ title: t.s5Title, text: t.s5P1 }, { text: t.s5P2 }],
    // Run 6 — the close.
    [
      { title: t.s6Title, text: t.s6P1 },
      { text: t.s6P2 },
      { text: t.s6P3 },
      { text: t.s6P4 },
      { text: t.s6P5 },
    ],
  ],

  captions: [
    // 01 — hero.
    [t.f1P1],
    // 02 — first `[IMAGE]` marker.
    [t.f2P1],
    // 03 — second `[IMAGE]` marker.
    [t.f3P1],
    // 04 — third `[IMAGE]` marker.
    [t.f4P1],
  ],

  quotes: [{ text: t.q1 }, { text: t.q2 }],
} as const
